module.exports = __webpack_public_path__ + "static/media/card.c018c885.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card.svg
// module id = 263
// module chunks = 0